import Property from '../models/property'

export default {

    /**
     * @param {VuexState} stateStore
     * @returns {boolean}
     */
    guestSignedIn: stateStore => stateStore.authContext && stateStore.authContext.type === 'guest',

    /**
     * @param {VuexState} stateStore
     * @returns {Property}
     */
    selectedProperty: stateStore => stateStore.property && !Number.isNaN(stateStore.property.id)
        ? Property.ensure(stateStore.property) : null,

    /**
     * @param {VuexState} stateStore
     * @returns {boolean}
     */
    userSignedIn: stateStore => stateStore.authContext &&
        (stateStore.authContext.type === 'account' || stateStore.authContext.type === 'external'),
}
